import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
	defaultCompanyLogoURL,
	defaultCompanyCoverPhoto,
} from "../../../../utils/constants";
import { WebIcon, LocationIcon } from "../../../common/icons";
import "./style.css";

const Preview = ({ company }) => {
	const { t } = useTranslation();
	return (
		<div className="preview_companyProfile_container">
			<div className="preview_companyProfile_container_grid">
				<div
					className="preview_grid_profileTop"
					style={{
						background: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),url(${
							company.coverPhoto ? company.coverPhoto : defaultCompanyCoverPhoto
						}) no-repeat center center/cover`,
					}}
				>
					<div className="row_1">
						<img
							src={company.logo ? company.logo : defaultCompanyLogoURL}
							alt=""
						/>
						<span className="companyName">
							{company.nameInEnglish ? company.nameInEnglish : company.name}
						</span>
					</div>
					<div className="row_2">
						<span className="companyIndustry">{company.industry}</span>
					</div>
					<div className="row_2">
						<LocationIcon width={16} height={16} />
						<span className="companyIndustry">{company.address}</span>
					</div>
					<div className="row_2">
						<WebIcon width={16} height={16} />
						<span className="companyWebsite">
							<a href={company.website} target="_blank" rel="noreferrer">
								{company.website}
							</a>{" "}
						</span>
					</div>
				</div>
				<div className="preview_grid_profileAbout">
					<div className="sectionTag">
						<span>
							{t("accountSetting_body_sectionBadge_noOfEmploee")}:{" "}
							{company.size}
						</span>
					</div>
					<span className="sectionTitle">
						{t("accountSetting_body_sectionHeader_companyInfo")}
					</span>
					<p className="sectionDescription">{company.description}</p>
					{company.voiceOfSeniors && company.voiceOfSeniors.length > 0 && (
						<span className="sectionTitle">
							{t("accountSetting_body_sectionHeader_voiceOfSenior")}
						</span>
					)}
					{company.voiceOfSeniors &&
						company.voiceOfSeniors.map((voice) => (
							<>
								<div className="voice_card_container">
									<div
										style={{
											display: "flex",
											justifyContent: "space-between",
											width: "100%",
										}}
									>
										<div className="voice_card_body_row">
											<div className="header">
												{t("accountSetting_voiceOfSenior_card_name")}
											</div>
											<div className="body">{voice.name}</div>
										</div>
									</div>
									<div className="voice_card_body_row">
										<div className="header">
											{t("accountSetting_voiceOfSenior_card_position")}
										</div>
										<div className="body">{voice.position}</div>
									</div>
									<div className="voice_card_body_row">
										<div className="header">
											{t("accountSetting_voiceOfSenior_card_year")}
										</div>
										<div className="body">{voice.yearOfEmployment}</div>
									</div>
									<div className="voice_card_body_row">
										<div className="header">
											{t("accountSetting_voiceOfSenior_card_college")}
										</div>
										<div className="body">{voice.collegeName}</div>
									</div>
									<div className="voice_card_body_row textBox">
										<div className="header">
											{t("accountSetting_voiceOfSenior_card_comment")}:
										</div>
										<div className="body preWrap">{voice.comments}</div>
									</div>
								</div>
							</>
						))}
				</div>
			</div>
		</div>
	);
};

export default Preview;
